import { type DocNode } from '@atlaskit/adf-schema';
import { type MessageFileId } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import {
	StoreActionLoggableName,
	type FollowUpSendAgentIdentity,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { addStoreChatItem } from './addStoreChatItem';
import { createSafeAction, type SafeAction } from './createSafeAction';
import { createStoreHuman } from './createStoreHuman';
import type { ChatStoreAction } from './types';

type AddHumanMessageArgs = {
	id: string;
	content: DocNode;
	conversationId?: string;
	isFromSeededConversation?: boolean;
	requestId?: string;
	fileUploads?: MessageFileId[];
	followUpAgentIdentity?: FollowUpSendAgentIdentity;
};

export const addHumanMessage: SafeAction<[AddHumanMessageArgs]> = createSafeAction(
	StoreActionLoggableName.addHumanMessage,
	({
		id,
		content,
		conversationId: conversationIdParam,
		isFromSeededConversation = false,
		requestId,
		fileUploads,
		followUpAgentIdentity,
	}: AddHumanMessageArgs): ChatStoreAction =>
		({ getState, dispatch }) => {
			const conversationId = conversationIdParam ?? getState().currentConversationId;
			dispatch(
				addStoreChatItem({
					message: {
						...createStoreHuman(id, content, isFromSeededConversation, requestId, fileUploads),
						...(followUpAgentIdentity ? { followUpAgentIdentity } : {}),
					},
					conversationId,
				}),
			);
		},
);
